import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

export interface UserData {
  name: string;
  age: number;
}

@Component({
  selector: 'app-table-common',
  templateUrl: './table-common.component.html',
  styleUrl: './table-common.component.scss'
})
export class TableCommonComponent extends MatPaginatorIntl implements OnInit {
  override itemsPerPageLabel = 'Số mục trên mỗi trang:';
  @Input() data: any[] = []; // Dữ liệu đầu vào cho bảng
  @Input() columns: any[] = []; // Danh sách các tên cột
  @Input() pageSize = 10; // Mặc định page size
  @Input() pageSizeOptions = [5, 10, 20]; // Các lựa chọn cho page size
  @Input() totalItems = 100; // Tổng số mục
  @Input() currentPageIndex = 0; // Trang hiện tại
  // Các hành động
  @Input() actions : any[]=[];

  @Output() pagingChanged = new EventEmitter<{ pageIndex: number; pageSize: number }>();

  get displayedColumns(): string[] {
    return [...this.columns.map(column => column.key), 'action'];
  }
  onPageSizeChange(event: any) {
    this.pageSize = event.value;
    this.onPageChange({ pageSize: this.pageSize, pageIndex: this.currentPageIndex });
  }

  onPageChange(event: any) {
    console.log('Trang:', event.pageIndex, 'Với page size:', event.pageSize);
    // Xử lý thay đổi trang và page size ở đây
    this.pagingChanged.emit({
      pageIndex:  event.pageIndex,
      pageSize: event.pageSize
    });
  }

  dataSource: MatTableDataSource<any>;

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.data);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && changes['data'].currentValue) {
      // cập nhật lại khi dữ liệu thay đổi
      if (this.dataSource) {
        this.dataSource.data = changes['data'].currentValue;
      } else {
        this.dataSource = new MatTableDataSource(changes['data'].currentValue);
      }
    }
  }
}
